import React from 'react';
import ModalModule from '../modal';
import Utils from '../utils';

const { Modal } = ModalModule;
const { Navigation } = Utils;

const PastDueServiceFeesModal = ({ modalId }) => (
	<Modal
		modalId={modalId}
		className="common-payment past-due-service-fees-modal"
		header="Past Due Service Fees"
		primaryButton={{
			text: 'OK',

			// redirect user to Payment Settings tab in Account
			onClick: () => Navigation.navigateTo('editPaymentMethod'),
		}}
	>
		<p>
			Your payment method for Service Fees has expired or is no longer valid.
			Please update your payment method before continuing. Some features
			including the ability to purchase postage will not be available until the
			payment method is updated.
		</p>
	</Modal>
);

export default PastDueServiceFeesModal;
